/**
 * When REACT_APP_API_URL is set (e.g. https://robotic-tc.com/api), API calls go
 * directly to that host instead of through the CRA dev-server proxy.
 * Leave unset for same-origin /api (production nginx or local proxy).
 */
export function getApiOrigin() {
  const apiUrl = (process.env.REACT_APP_API_URL || '').trim();
  if (!apiUrl) return '';
  return apiUrl.replace(/\/api\/?$/, '');
}

export function resolveApiUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const origin = getApiOrigin();
  return origin ? `${origin}${normalized}` : normalized;
}
